export default __webpack_public_path__ + "static/enjoyye-logo-0591fefe9cdefcde725a8a0379a34e01.png";